import outbound from './outbound'

export default [...outbound]
